import { createSpreadableBem } from "/Helpers/createBem";
import { ListItemMetadata } from "../ListItemCallForProposals/ListItemCallForProposals";
import "./ListItemGroupCallForProposals.scss";
import {
  CalendarBlankIcon,
  HideFor,
  InfoSmallIcon,
  ListItemCallForProposals,
} from "/App.Components";

import { NewsListItemProps } from "/Models/Generated/NewsListItemProps";
import { NewsListSectionProps } from "/Models/Generated/NewsListSectionProps";

interface Props extends NewsListSectionProps {
  overrideGetMetaDataItems?: (
    item: NewsListItemProps,
  ) => ListItemMetadata | undefined;
  iconType: "active" | "expired" | "allocations";
  showLabel?: boolean;
}

const ListItemGroupCallForProposals: React.FC<Props> = ({
  sectionHeading,
  items,
  overrideGetMetaDataItems,
  showLabel,
  iconType,
}) => {
  const getMetadataItems = (item: NewsListItemProps) =>
    overrideGetMetaDataItems
      ? overrideGetMetaDataItems(item)
      : {
          firstRow: item.published && (
            <InfoSmallIcon text={item.published} icon={CalendarBlankIcon} />
          ),
        };

  const bem = createSpreadableBem("list-item-group-call-for-proposals-norad");
  return (
    <li {...bem("")}>
      {sectionHeading && (
        <>
          <h2 {...bem("__section-heading")}>{sectionHeading}</h2>
          <HideFor desktop desktopMedium desktopLargeUp>
            <div {...bem("__section-heading-divider")}></div>
          </HideFor>
        </>
      )}

      <ol {...bem("__items")}>
        {items &&
          items.map((item, idx) => (
            <ListItemCallForProposals
              label={showLabel ? item.label : undefined}
              link={item.link}
              key={"list-item" + idx}
              metadataItems={getMetadataItems(item)}
              iconType={iconType}
              heading={item.heading}
            />
          ))}
      </ol>
      <HideFor mobile tablet>
        <div {...bem("__divider")}></div>
      </HideFor>
    </li>
  );
};

export default ListItemGroupCallForProposals;
